'use strict'

let satni = {}

var dictlist = require('../dictlist')
var articles = require('../articles')
var util = require('../../helpers/util')
var config = require('../../helpers/env.json')[process.env.NODE_ENV || 'development']

satni.getDictList = function() {
	return m.request
    ({
        method: "GET", 
        url: config.EXIST_URL + "/dictionaries", // + mx.translate.use(),
        type: dictlist.Dict,
        deserialize: util.maybeJSON
    })
}

satni.query = function(query, dict) {
	return m.request
	({
		method: "GET", 
		url: config.EXIST_URL + "/search?query=" + query + "&dict=" + dict,
		deserialize: util.maybeJSON,
		background: true
	})
}

satni.getArticle = function(article) {
	return m.request
	({
		method: 'GET',
		url: config.EXIST_URL + '/article/' + article,
		type: articles.Article,
		deserialize: util.maybeJSON
	})
}

module.exports = satni
